import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useMap } from "react-leaflet";
// Import `find` explicitly because browsers expose `window.find`, which returns a boolean
// and would prevent the panel offset from being applied.
import { find } from "lodash";

import { useMapContext } from "./MapContext";
import { useResponsiveFlag } from "../Utils/ResponsiveQueries";

export const useMoveMapCenterTo = () => {
  const { mapKey } = useMapContext();
  const leafletMap = useMap();

  const shownPanel = useSelector(({ map }) =>
    find(map[mapKey].panels.activePanels, panel => panel.isShown)
  );

  const { isDesktop } = useResponsiveFlag();

  return useCallback(
    (latitude, longitude, zoomLevel) => {
      if (!leafletMap) return;

      // Avoid issues with missing coordinates in component update and just don't try
      // to center the point instead of raising an error
      if (!latitude || !longitude) return;

      const point = leafletMap.latLngToContainerPoint([latitude, longitude]);

      if (shownPanel && !isDesktop) {
        const windowHeight = window.innerHeight;
        const availableHeight = shownPanel.element.offsetTop;
        point.y += (windowHeight - availableHeight) / 2;
      }

      const targetPosition = leafletMap.containerPointToLatLng(point);

      const targetZoomLevel = zoomLevel || leafletMap.getZoom();
      leafletMap.flyTo(targetPosition, targetZoomLevel);
    },
    [isDesktop, leafletMap, shownPanel]
  );
};
